import { z } from 'zod';
const INQUIRY_STATUSES = ['NEW', 'CONTACTED', 'ARCHIVED', 'SPAM'];
/**
 * ⚠️ **`website` and `elapsedMs` are anti-spam signals, not inquiry fields.**
 * They are accepted here so the endpoint can weigh them, and the controller
 * strips both before the row is written — they must never reach Prisma, which
 * has no columns for them.
 */
export const createInquirySchema = z.object({
    name: z.string().min(1).max(255),
    email: z.string().email().max(255),
    phone: z.string().max(50).optional(),
    eventType: z.string().max(100).optional(),
    estimatedDate: z.string().max(50).optional(),
    estimatedGuestCount: z.number().int().min(1).max(10000).optional(),
    message: z.string().max(5000).optional(),
    // Generous bounds on both: a rejected request tells a bot its payload was
    // wrong, and we would rather accept it and quarantine it silently.
    website: z.string().max(1000).optional(),
    elapsedMs: z.number().int().min(0).max(86_400_000).optional(),
});
export const updateInquirySchema = z.object({
    status: z.enum(INQUIRY_STATUSES),
});
//# sourceMappingURL=inquiry.js.map